/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'
import { usePartRequestsList } from '@/hooks/usePartRequests'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_authenticated/service-cases/$id/parts')({
  component: CasePartsTab,
})

function CasePartsTab() {
  const { t } = useTranslation()
  const { id } = useParams({ from: '/_authenticated/service-cases/$id' })
  const navigate = useNavigate()
  const { data: partRequestsData } = usePartRequestsList({ service_case_id: id })
  const partRequests = (partRequestsData as any)?.data ?? []

  if (partRequests.length === 0) {
    return <p className="text-sm text-muted-foreground p-4">No part requests linked to this case.</p>
  }

  return (
    <div className="space-y-2">
      {partRequests.map((pr: any) => (
        <div key={pr.id} className="p-3 border rounded-lg cursor-pointer hover:bg-muted/50" onClick={() => navigate({ to: `/part-requests/${pr.id}` })}>
          <div className="flex items-center justify-between">
            <span className="font-medium">{t('caseDetail:partRequest')}</span>
            <div className="flex gap-1"><Badge>{pr.status}</Badge><Badge variant="outline">{pr.urgency}</Badge></div>
          </div>
        </div>
      ))}
    </div>
  )
}
